/** Centre d’aide Rintintin — URL unique header / footer (tickets #635 / #649). */
export const HELP_CENTER_URL = 'https://support-rintintin.netlify.app/';
